import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { JobsService } from '../../../pages/pages/jobs/jobs.service';
import { Router } from '@angular/router';
import {
  alarmResponseStaleMinutes,
  formatDateTimeStamp,
  isLargeScreen,
} from '../../../../global.variable';
import { WebSocketService } from '../../services/web-socket.service';

@Component({
  selector: 'gtapp-user-live-jobs',
  standalone: false,
  templateUrl: './user-live-jobs.component.html',
  styleUrl: './user-live-jobs.component.scss',
})
export class UserLiveJobsComponent implements OnInit, OnDestroy {
  @Input() selectedUser: any = {};
  staleMinutes: any = alarmResponseStaleMinutes;
  largeView: Boolean = isLargeScreen;
  jobListData: any = [];
  previousLiveResponses: number = 0;
  rowsLiveResponses: number = 10;
  pageNumLiveResponses: number = 1;
  totalPagesLiveResponses: number = 0;
  sortKeyLiveResponses: any;

  searchParamsLiveResponses: any;
  otherParamsLiveResponses: any = {
    fixedRows: true,
    hideHeaders: !this.largeView,
    apiFiltering: true,
  };

  jobListTableDetails: any = [];
  jobListExists: boolean = false;

  webSocketSubscription: any;

  responseArrived: any = {};

  staleDataCheck: number = 0;
  refreshCalled: boolean = false;
  refreshBtnPressed: boolean = false;
  constructor(
    private jobService: JobsService,
    private router: Router,
    private webSocketService: WebSocketService,
  ) {}
  ngOnInit(): void {
    this.webSocketSubscription =
      this.webSocketService.webSocketSubject.subscribe((event: any) => {
        if (
          (event?.event === 'wsn_response_job_update' &&
            this.jobListData?.some((job: any) => job?.id == event?.data?.id)) ||
          event?.event == 'wsn_response_job_create'
        ) {
          this.staleDataCheck = 0;
          this.refreshBtnPressed = true;
          this.getLiveResponses(true, true);
        }
      });
    this.jobListTableDetails = this.getJobDetailView();

    this.getJobData();
  }
  ngOnDestroy(): void {
    if (this.webSocketSubscription) {
      this.webSocketSubscription?.unsubscribe();
    }
  }
  refreshData() {
    this.previousLiveResponses = 0;
    this.refreshBtnPressed = true;
    this.getLiveResponses();
  }
  getJobData() {
    if (this.largeView || this.selectedUser?.id) {
      this.getLiveResponses();
    } else {
      const cachedData = JSON.parse(
        sessionStorage.getItem(btoa('jobData')) || '{}',
      );

      if (!cachedData?.cachedTime) {
        // first time or cache is not there

        this.getLiveResponses();
        return;
      }

      if (new Date().getTime() > cachedData?.cachedTime + 5 * 60 * 1000) {
        this.staleDataCheck = Math.floor(
          (new Date().getTime() - cachedData?.cachedTime) / 60000,
        );
      }

      if (new Date().getTime() > cachedData?.cachedTime + 10 * 60 * 1000) {
        this.staleDataCheck = 0;
        // cache has become stale
        this.getLiveResponses();
        return;
      }

      this.jobListData = cachedData?.jobListData || [];
      this.otherParamsLiveResponses = {
        ...(cachedData?.otherParams || {}),
        fixedRows: true,
        hideHeaders: !this.largeView,
        apiFiltering: true,
      };

      this.jobListExists =
        this.otherParamsLiveResponses?.paginationData?.totalRows > 0;
    }
  }

  getLiveResponseCount(reqParams: any, body: any, itemExistsCheck = false) {
    let params: any = { get_count: 1, ...reqParams };

    this.jobService.getJobListData(body, params).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.otherParamsLiveResponses = {
          ...this.otherParamsLiveResponses,
          paginationData: {
            totalRows: response?.total_size,
            previousRows: this.previousLiveResponses,
            rows: this.rowsLiveResponses,
            pageNum: this.pageNumLiveResponses,
          },
        };
        if (itemExistsCheck) {
          this.jobListExists =
            this.otherParamsLiveResponses?.paginationData?.totalRows > 0;
        } else {
          this.jobListExists =
            this.jobListExists ||
            this.otherParamsLiveResponses?.paginationData?.totalRows > 0;
        }
      }
      this.responseArrived['count'] = true;
      this.cacheData();
    });
  }

  getLiveResponses(getCount: boolean = true, itemExistsCheck: boolean = false) {
    let params: any = {};
    let body: any = { type_identities: [0], status_identities: [0, 4, 5, 8] };

    if (this.rowsLiveResponses) {
      body['rows'] = this.rowsLiveResponses;
    }
    if (this.previousLiveResponses) {
      body['previous'] = this.previousLiveResponses;
    }
    if (this.sortKeyLiveResponses) {
      body['sort_key'] = this.sortKeyLiveResponses;
    }
    if (this.searchParamsLiveResponses)
      body.search_filter = this.searchParamsLiveResponses;
    if (this.selectedUser?.id) {
      body.assignee_ids = [this.selectedUser?.id];
    }
    this.responseArrived = {};

    if (getCount) this.getLiveResponseCount(params, body, itemExistsCheck);

    this.jobService.getJobListData(body, params).subscribe((response: any) => {
      this.jobListData = response?.data || [];
      this.responseArrived['list'] = true;
      this.cacheData();
      if (this.staleDataCheck) {
        this.staleDataCheck = 0;
        this.refreshCalled = true;
        setTimeout(() => {
          this.refreshCalled = false;
        }, 2000);
      }
    });
  }
  cacheData() {
    //https://app.shortcut.com/sendem/story/12320/conditional-home-screen-components-on-mobile-view
    //cache only first page
    if (this.previousLiveResponses !== 0) return;
    // cache only when both data arrives
    if (!(this.responseArrived?.count && this.responseArrived?.list)) return;

    sessionStorage.setItem(
      btoa('jobData'),
      JSON.stringify({
        cachedTime: new Date().getTime(),
        jobListData: this.jobListData,
        otherParams: this.otherParamsLiveResponses,
      }),
    );
  }
  searchColumnLiveResponses(event: any) {
    this.previousLiveResponses = 0;
    this.searchParamsLiveResponses = event?.searchParams || {};
    this.getLiveResponses();
  }
  sortColumnLiveResponses(body: any) {
    this.sortKeyLiveResponses = body?.sortList || [];
    this.getLiveResponses(false);
  }

  onChangePaginationLiveResponses(data: any) {
    this.previousLiveResponses = data?.paginationData?.previousRows;
    this.pageNumLiveResponses = data?.paginationData?.pageNum;
    this.rowsLiveResponses = data?.paginationData?.rows;

    this.otherParamsLiveResponses.paginationData = {
      ...data?.paginationData,
      fixedRows: true,
    };
    this.getLiveResponses(false);
  }
  routeToJob(jobData: any) {
    this.router.navigate([`/job-detail/JOBID`], {
      queryParams: { jId: jobData?.id },
    });
  }
  getJobDetailView() {
    const deskTopTableItems = [
      {
        tableColumnStyle: {
          'white-space': 'pre-line',
          'vertical-align': 'middle',
        },

        header: 'Updated',
        name: 'modified_date',
        datetimeObj: true,
        dateRangeKey: 'modified_date',
        sortKey: 'modified_date',
        conditionalColumnStyle: (row: any) => {
          if (
            [1, 2, 3, 9, 10, 11, 12, 13].includes(
              row?.status_data?.status_identity,
            )
          )
            return { 'vertical-align': 'middle' }; // if job status is complete,closed, cancelled, no need to worry about this
          const isStatusNew =
            row?.status_data?.status_identity === 0 &&
            row?.status?.toLowerCase() === 'new';

          if (isStatusNew) {
            // check if the status has not been changes in the last 15 minutes then blink it
            const jobCreatedDateTime = new Date(row?.created_date).getTime();
            const staleDateTime = new Date().getTime() - 1000 * 60 * 15;
            if (jobCreatedDateTime < staleDateTime) {
              return {
                'color': 'var(--bs-light)',
                // 'background-color': 'var(--bs-danger)',
                'animation-name': 'jobAlert',
                'animation-duration': '0.25s',
                'animation-iteration-count': 'infinite',
                'animation-direction': 'alternate',
                'vertical-align': 'middle',
              };
            }
          }

          const modifiedDate = new Date(row?.modified_date).getTime();
          const staleDateTime =
            new Date().getTime() - 1000 * 60 * this.staleMinutes;

          if (
            modifiedDate < staleDateTime
            //  if the job has not been updated in the last  this.staleMinutes
          ) {
            return {
              'color': 'var(--bs-white)',
              'background-color': 'var(--bs-danger)',
            };
          }
          return { 'vertical-align': 'middle', 'white-space': 'pre-line' };
        },
        showHeader: true,
      },
      {
        header: 'Docket No.',
        searchKey: 'job_key',
        tableColumnStyle: {
          'white-space': 'pre-line',
          'font-size': '0.8rem',
          'vertical-align': 'middle',
        },
        nestedValue: (row: any) => {
          let appendList = [row?.job_key];
          if (row?.ext_job_id) appendList.push(`[${row?.ext_job_id}]`);

          return appendList.join('\n');
        },
        showHeader: true,
      },
      {
        tableColumnStyle: {
          'white-space': 'pre-line',
        },
        nestedValue: (row: any) => {
          let typeList: any = [];
          if (row?.nested_job_type) typeList.push(row?.nested_job_type);
          if (row?.monitoring_company)
            typeList.push(`[${row?.monitoring_company}]`);
          return typeList?.join('\n');
        },
        showHeader: true,
      },
      {
        header: 'Site',
        name: 'site_name',
        searchKey: 'site_name',
        tableColumnStyle: {
          'white-space': 'pre-line',
        },
        suffixNestedValue: (row: any) => {
          return `\n[${row?.company_name}]` + '\n' + row?.site_address;
        },
        suffixStyle: { 'font-size': '0.8rem' },
        showHeader: true,
      },
      {
        header: 'Guard',
        nestedValue: (row: any) => {
          if (row?.assignee !== '') {
            return row?.assignee;
          } else {
            return 'NOT ASSIGNED';
          }
        },

        tableColumnStyle: {
          'white-space': 'pre-line',
          'vertical-align': 'middle',
        },

        searchKey: 'assignee',
        showHeader: !this.selectedUser?.id,
      },
      {
        header: 'Status',

        tableColumnStyle: {
          'white-space': 'pre-line',
          'vertical-align': 'middle',
        },

        suffixNestedValue: (row: any) => {
          let appendList = [];
          if (row?.status_data?.name) appendList.push(row?.status_data?.name);
          if (row?.guard_eta && Number(row?.guard_eta) > 0)
            appendList = [...appendList, ...this.getEtaValue(row)];

          return appendList.join('\n');
        },

        conditionalColumnStyle: (row: any) => {
          return this.getJobStatusStyle(row);
        },

        showHeader: true,
      },
    ];

    if (this.largeView) {
      return deskTopTableItems?.filter((item: any) => item?.showHeader);
    } else {
      return [
        {
          nestedValue: (row: any) => {
            return this.selectedUser?.id ? row?.site_name : row?.assignee;
          },

          tableColumnStyle: {
            'font-size': '18px',
            'font-weight': '400',
            'color': 'var(--text-secondary)',
            'white-space': 'pre-line',
            'vertical-align': 'top',
          },

          suffixNestedValue: (row: any) => {
            let suffixValues = [''];
            if (!this.selectedUser?.id) {
              suffixValues.push(row?.site_name);
            }
            if (row?.site_address) {
              suffixValues.push(row?.site_address);
            }

            return suffixValues?.join('\n');
          },
          suffixStyle: {
            'font-size': '13px',
          },
        },
        {
          nestedValue: (row: any) => {
            if (
              [1, 2, 3, 9, 10, 11, 12, 13].includes(
                row?.status_data?.status_identity,
              )
            )
              return null; // if job status is complete,closed, cancelled, no need to worry about this

            return String(
              formatDateTimeStamp(row?.modified_date, 'd MMM y HH:mm', 'en_US'),
            );
          },
          conditionalColumnDataStyle: (row: any) => {
            if (
              [1, 2, 3, 9, 10, 11, 12, 13].includes(
                row?.status_data?.status_identity,
              )
            )
              return {
                'display': 'flex',
                'justify-content': 'flex-end',
                'margin-bottom': '1rem',
              }; // if job status is complete,closed, cancelled, no need to worry about this
            const isStatusNew =
              row?.status_data?.status_identity === 0 &&
              row?.status?.toLowerCase() === 'new';

            if (isStatusNew) {
              // check if the status has not been changes in the last 15 minutes then blink it
              const jobCreatedDateTime = new Date(row?.created_date).getTime();
              const staleDateTime = new Date().getTime() - 1000 * 60 * 15;
              if (jobCreatedDateTime < staleDateTime) {
                return {
                  'background-color': 'var(--bs-red)',
                  'color': 'var(--bs-gray-100)',
                  'width': 'fit-content',
                  'border': '1px solid #333',
                  'border-radius': '3px',
                  'font-size': 'small',
                  'padding-left': '0.5rem',
                  'padding-right': '0.5rem',
                  'animation-name': 'jobAlert',
                  'animation-duration': '0.25s',
                  'animation-iteration-count': 'infinite',
                  'animation-direction': 'alternate',
                  'display': 'flex',
                  'justify-content': 'flex-end',
                  'margin-bottom': '1rem',
                  'margin-left': 'auto',
                };
              }
            }

            const modifiedDate = new Date(row?.modified_date).getTime();
            const staleDateTime =
              new Date().getTime() - 1000 * 60 * this.staleMinutes;

            if (
              modifiedDate < staleDateTime
              //  if the job has not been updated in the last  this.staleMinutes
            ) {
              return {
                'color': 'var(--bs-red)',
                'font-size': '12px',
                'display': 'flex',
                'justify-content': 'flex-end',
                'margin-bottom': '1rem',
              };
            }
            return {
              'font-size': '12px',
              'display': 'flex',
              'justify-content': 'flex-end',
              'margin-bottom': '1rem',
            };
          },
          tableColumnStyle: {
            'vertical-align': 'top',
            'font-size': '13px',
            'text-align': 'end',
          },

          suffixNestedValue: (row: any) => {
            let appendList = [];
            if (row?.status_data?.name) appendList.push(row?.status_data?.name);
            // if (row?.guard_eta && Number(row?.guard_eta) > 0)
            //   appendList = [...appendList, ...this.getEtaValue(row)];

            return row?.status_data?.name;
          },
          conditionalSuffixStyle: (row: any) => {
            return this.getJobStatusStyle(row);
          },
          showItem: true,
        },

        // {
        //   tableColumnStyle: {
        //     'white-space': 'pre-line',
        //     'text-align': 'end',
        //     'vertical-align': 'top',
        //   },
        // suffixNestedValue: (row: any) => {
        //   if (
        //     [1, 2, 3, 9, 10, 11, 12, 13].includes(
        //       row?.status_data?.status_identity,
        //     )
        //   )
        //     return null; // if job status is complete,closed, cancelled, no need to worry about this

        //   return String(
        //     formatDateTimeStamp(row?.modified_date, 'd MMM y HH:mm', 'en_US'),
        //   );
        // },
        // conditionalSuffixStyle: (row: any) => {
        //   if (
        //     [1, 2, 3, 9, 10, 11, 12, 13].includes(
        //       row?.status_data?.status_identity,
        //     )
        //   )
        //     return {}; // if job status is complete,closed, cancelled, no need to worry about this
        //   const isStatusNew =
        //     row?.status_data?.status_identity === 0 &&
        //     row?.status?.toLowerCase() === 'new';

        //   if (isStatusNew) {
        //     // check if the status has not been changes in the last 15 minutes then blink it
        //     const jobCreatedDateTime = new Date(row?.created_date).getTime();
        //     const staleDateTime = new Date().getTime() - 1000 * 60 * 15;
        //     if (jobCreatedDateTime < staleDateTime) {
        //       return {
        //         'background-color': 'var(--bs-red)',
        //         'color': 'var(--bs-gray-100)',
        //         'width': 'fit-content',
        //         'border': '1px solid #333',
        //         'border-radius': '3px',
        //         'font-size': 'small',
        //         'padding-left': '0.5rem',
        //         'padding-right': '0.5rem',
        //         'animation-name': 'jobAlert',
        //         'animation-duration': '0.25s',
        //         'animation-iteration-count': 'infinite',
        //         'animation-direction': 'alternate',
        //       };
        //     }
        //   }

        //   const modifiedDate = new Date(row?.modified_date).getTime();
        //   const staleDateTime =
        //     new Date().getTime() - 1000 * 60 * this.staleMinutes;

        //   if (
        //     modifiedDate < staleDateTime
        //     //  if the job has not been updated in the last  this.staleMinutes
        //   ) {
        //     return {
        //       'color': 'var(--bs-red)',
        //       'font-size': '12px',
        //     };
        //   }
        //   return { 'font-size': '12px' };
        // },

        // prefixNestedValue: (row: any) => {
        //   let appendList = [''];
        //   if (row?.status_data?.name) appendList.push(row?.status_data?.name);
        //   // if (row?.guard_eta && Number(row?.guard_eta) > 0)
        //   //   appendList = [...appendList, ...this.getEtaValue(row)];

        //   return appendList.join('\n');
        // },
        // conditionalPrefixStyle: (row: any) => {
        //   return this.getJobStatusStyle(row);
        // },
        // },
      ];
    }
  }
  getNestedAssignees(rowData: any, maxNumber: any = 2) {
    if (rowData?.assignee?.length > maxNumber) {
      return `${rowData?.assignee?.slice(0, maxNumber)} ...`;
    } else {
      return rowData?.assignee;
    }
  }
  getEtaValue(jobData: any) {
    const diffInTime = jobData?.guard_eta - new Date().getTime();

    const diffInMinutes = Math.floor(diffInTime / (1000 * 60)) + 1;
    return [
      `ETA: ${formatDateTimeStamp(jobData?.guard_eta, 'h:mm a', 'en_US')} `,
      diffInTime >= 0
        ? `${diffInMinutes} minutes`
        : `${diffInMinutes * -1} mins late`,
    ];
  }
  getJobStatusStyle(jobData: any) {
    let customStyle: any = {};
    let additionalStyle: any = {};
    if (
      jobData?.guard_eta &&
      Number(jobData?.guard_eta) > 0 &&
      jobData?.type_identity === 0
    ) {
      //https://app.shortcut.com/sendem/story/9210/highlight-repsonse-jobs-with-eta-beyond-80-40-day-night-minutes-from-response-creation-time
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const totalMinutes = hours * 60 + minutes;
      const isItDay = totalMinutes >= 6 * 60 && totalMinutes < 18 * 60;

      const createdDate = new Date(jobData?.created_date).getTime();

      const highlightJob =
        (jobData?.guard_eta - createdDate) / 60000 > (isItDay ? 80 : 40);
      if (highlightJob) {
        additionalStyle = {
          'animation-name': 'jobAlert',
          'animation-duration': '0.25s',
          'animation-iteration-count': 'infinite',
          'animation-direction': 'alternate',
        };
      }
    }

    if (this.largeView) {
      customStyle = {
        'color': `${jobData?.status_data?.additional_info?.style?.snubbed?.color}`,
        'background-color': `${jobData?.status_data?.additional_info?.style?.snubbed['background-color']}`,
        'text-align': 'center',
        'white-space': 'pre-line',
        'vertical-align': 'middle',
        ...additionalStyle,
      };
    } else {
      const bgColor =
        jobData?.status_data?.additional_info?.style?.snubbed[
          'background-color'
        ];
      customStyle = {
        'color': `${jobData?.status_data?.additional_info?.style?.snubbed?.color}`,
        'background-color': `${bgColor}`,
        'border': `1px solid ${bgColor}`,
        'border-radius': '5px',
        'padding': '0 0.5rem',
        'display': 'flex',
        'justify-content': 'flex-end',
        'margin-bottom': '1rem',
        'margin-left': 'auto',
        'white-space': 'pre-line',
        ...additionalStyle,
      };
    }
    if (jobData?.guard_eta > 0) {
      const diffInTime = jobData?.guard_eta - new Date().getTime();
      if (diffInTime < 0) {
        // this implies that eta provided by user has passed and he is late
        customStyle['background-color'] = 'var(--bs-danger)';
      }
    }

    return customStyle;
  }
}
